<template>
  <div class="container">
    <div class="fui-list follow_topbar" style="background: #444444">
      <div class="fui-list-media">
        <img class="" style="width:1.5rem" :src='config.logo_wx_mobile'>
      </div>
      <div class="fui-list-inner">
        <div class="text" style="color: #ffffff;">欢迎进入<span class="text-danger"></span><br>关注公众号，享专属服务</div>
      </div>
      <div class="fui-list-angle">
        <div class="btn btn-success external" id="followbtn" style="border: none; color: #ffffff; background: #04be02;" @click="ewmshow">点击关注</div>
      </div>
    </div>
    <div class="fixed-suspension-layer" :style="showimageStyle">
      <div class="fixed-suspension-con">
        <img class="perfundo__image" :src="config.site_logowx" >
        <p class="text-white">长按识别二维码关注</p>
      </div>
      <div class="close-fixed-suspension" @click="ewmclose"></div>
    </div>
    <div class="fui-topmenu-height">
      <!--为了撑起topmenu的高度-->
    </div>
    <home-common-search :from='"home"'></home-common-search>
    <index-banner v-if="banners && banners.length > 0" :items="banners"></index-banner>
    <index-menu  :items="navs"></index-menu>
    <index-article class="mb-5" :items="articles"></index-article>
    <index-floor-ads v-if="floorAds" :ad="floorAds[0]"></index-floor-ads>
    <index-three-ads :items="promotionAds"></index-three-ads>
    <index-product-list
            :items="goodProducts"
            title="热门推荐"
            :type="popular"
            v-if="goodProducts && goodProducts.length > 0"
    ></index-product-list>
    <index-product-list
            :items="hotProducts"
            title="销量排行"
            :type="sale"
            v-if="hotProducts && hotProducts.length > 0"
    ></index-product-list>
    <index-floor-ads v-if="floorAds" :ad="floorAds[1]"></index-floor-ads>
    <index-product-list
            :items="recentlyProducts"
            title="新品上架"
            :type="recently"
            v-if="recentlyProducts && recentlyProducts.length > 0"
    ></index-product-list>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { Toast  } from 'mint-ui'
  import IndexProductList from './IndexProductList'
  import HomeCommonSearch from '../common/HomeCommonSearch'
  import IndexBanner from './IndexBanner'
  import IndexMenu from './IndexMenu'
  import IndexFloorAds from './IndexFloorAds'
  import IndexThreeAds from './IndexThreeAds'
  import IndexArticle from './IndexArticle'
  export default {
    name: 'HomeIndex',
    data () {
      return {
        ewmVisible: 'hidden',
        isshowBacktop: true,
        popular: '',
        sale: 'goods_salenum',
        recently: 'goods_addtime'
      }
    },
    components: {
      IndexProductList,
      HomeCommonSearch,
      IndexBanner,
      IndexMenu,
      IndexFloorAds,
      IndexThreeAds,
      IndexArticle
    },
    mounted () {
    },
    created: function () {
      this.fetchHomeAd({}).then(
              response => {
              },
              error => {
                Toast(error.message)
              }
      )
      this.fetchHomeArticle({}).then(
              response => {
              },
              error => {
                Toast(error.message)
              }
      )
      this.fetchHomeProduct({}).then(
              response => {
              },
              error => {
                Toast(error.message)
              }
      )
      this.fetchConfig({}).then(
              response => {
              },
              error => {
                Toast(error.message)
              }
      )
    },
    computed: {
      ...mapState({
        config: state => state.config.config,
        banners: state => state.home.banners,
        navs: state => state.home.navs,
        floorAds: state => state.home.floorAds,
        promotionAds: state => state.home.promotionAds,
        articles: state => state.home.articles,
        hotProducts: state => state.home.hotProducts,
        recentlyProducts: state => state.home.recentlyProducts,
        goodProducts: state => state.home.goodProducts
      }),
      showimageStyle: function () {
        return {
          'visibility': this.ewmVisible
        }
      }
    },
    methods: {
      ...mapActions({
        fetchHomeAd: 'fetchHomeAd',
        fetchHomeArticle: 'fetchHomeArticle',
        fetchHomeProduct: 'fetchHomeProduct',
        fetchConfig: 'fetchConfig'
      }),
      ewmshow(){
        this.ewmVisible = 'visible'
      },
      ewmclose(){
        this.ewmVisible = 'hidden'
      }
    }
  }
</script>

<style scoped>
  .fixed-suspension-layer{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    visibility: hidden;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.9);
  }
  .fixed-suspension-layer .fixed-suspension-con{
    width: 100%;
    height: 500px;
    margin: 0 auto;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -50%;
    margin-top: -30%;
    text-align: center;
  }
  .text-white{
    color: #fff;
    text-align: center;
    margin-top: 10px;
  }
  .fixed-suspension-layer .fixed-suspension-con .perfundo__image{
   width: 70%;
  }
  .close-fixed-suspension{
    position: absolute; width: 36px; height: 36px; top: 1rem; z-index: 2; background: url(../../../assets/image/home/close-fixed-suspension.png); background-size: cover; right: 1rem; cursor: pointer;
  }

  .follow_topbar:active {
    background: rgba(0, 0, 0, 0.8);
  }

  .follow_topbar:before {
    border: none;
  }
  .follow_topbar {
    height: 2rem;
    background: rgba(51, 51, 51, 1);
    padding: 0.3rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    color: #fff;
    overflow: hidden;
  }

  .follow_topbar .fui-list-media,
  .follow_topbar .fui-list-media img.radius {
    border-radius: 0.3rem
  }

  .follow_topbar .fui-list-media img.circle {
    border-radius: 1.8rem
  }

  .follow_topbar .fui-list-inner .text {
    color: #fff;
    font-size: 0.5rem;
    line-height: 0.8rem;
  }

  .follow_topbar .fui-list-angle {
    position: absolute;
    right: 0.2rem;
  }

  .follow_topbar .fui-list-angle .btn {
    height: 1rem;
    padding: 0 0.3rem;
    margin: 0;
    line-height: 1rem;
    font-size: 0.4rem;
    border-radius: 0.4rem;
  }

  .follow_topbar ~ .fui-content {
    top: 2.6rem
  }
  .fui-topmenu-height{
    height: 2.2rem;
  }
  .fui-list {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    padding:0.2rem 0.4rem ;
    -moz-transition-duration: 300ms;
    -webkit-transition-duration: 300ms;
    transition-duration: 300ms;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    overflow: hidden;
  }

  .fui-list.align-start {
    -webkit-box-align: start;
    -webkit-align-items: start;
    -ms-flex-align: start;
    align-items: start
  }

  .fui-list:before {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    right: .5rem;
    height: 1px;
    border-top: 1px solid #D9D9D9;
    color: #D9D9D9;
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.5);
    -ms-transform: scaleY(0.5);
    transform: scaleY(0.5);
    left: .6rem;
  }

  .fui-list:first-child:before {
    display: none;
  }

  .fui-list:active {
    background: #ececec;
  }

  .fui-list.noclick:active {
    background: #fff;
  }

  .fui-list a {
    color: #666;
  }
  .fui-list-media {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-shrink: 0;
    -ms-flex: 0 0 auto;
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    -webkit-box-lines: single;
    -moz-box-lines: single;
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
    box-sizing: border-box;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    margin-right: .5rem;
    color: #aaa;
    position: relative;
  }

  .fui-list-media .title {
    background: rgba(0, 0, 0, 0.8);
    color: white;
    font-size: 0.7rem;
    height: 1rem;
    right: 0;
    left: 0;
    line-height: 1rem;
    font-size: 0.6rem;
    padding: 0 0.15rem;
    position: absolute;
    bottom: 0;
    text-align: center;
    vertical-align: top;
    z-index: 100;
  }

  .fui-list-media img {
    width: 2.5rem;
  }

  .fui-list-media img.round {
    border-radius: .3rem;
  }

  .fui-list-media .badge {
    background: red none repeat scroll 0 0;
    border-radius: 0.5rem;
    color: white;
    font-size: 0.7rem;
    height: 0.9rem;
    right: -.35rem;
    line-height: 0.9rem;
    min-width: 0.9rem;
    padding: 0 0.15rem;
    position: absolute;
    top: -.3rem;
    text-align: center;
    vertical-align: top;
    z-index: 100;
  }
  .fui-list-inner{
    font-size: 0.5rem;
  }
  .fui-remark:after {
    content: " ";
    display: inline-block;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    height: 0.4rem;
    width: 0.4rem;
    border-width: 1px 1px 0 0;
    border-color: #b2b2b2;
    border-style: solid;
    position: relative;
    top: -1px;
    margin-left: .1em;
  }

</style>
